import { render, staticRenderFns } from "./coda-table.vue?vue&type=template&id=3ab7c524&scoped=true&"
import script from "./coda-table.ts?vue&type=script&lang=ts&"
export * from "./coda-table.ts?vue&type=script&lang=ts&"
import style0 from "./coda-table.scss?vue&type=style&index=0&id=3ab7c524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7c524",
  null
  
)

export default component.exports